import * as Sentry from "@sentry/react";

import { Integrations } from "@sentry/tracing";

const package_json = require("../../package.json");

class BugTracker {
  public static init(release: string = "") {
    let sentryOptions: { [key: string]: string | number | boolean | any } = {
      dsn: "https://880cc354d341428faa96e265d093d26d@o38114.ingest.sentry.io/5689658",
      //      integrations: [new Integrations.BrowserTracing()],
      enableAutoSessionTracking: false,
      maxBreadcrumbs: 50,
      debug: __DEV__, //  If debug is enabled SDK will attempt to print out useful debugging information if something goes wrong with sending the event.
      environment: __DEV__ ? "development" : "production",
      sendDefaultPii: __DEV__, // If this flag is enabled, certain personally identifiable information (PII) is added by active integrations.
      tracesSampleRate: __DEV__ ? 1.0 : 0.1,
    };
    console.log(process.env.npm_package_version);
    sentryOptions = {
      ...sentryOptions,
      release: release !== "" ? release : package_json.version,
    };

    Sentry.init(sentryOptions);
  }

  public static setScope(email: string) {
    Sentry.configureScope(function (scope) {
      scope.setUser({ email: email });
    });
  }

  public static captureException(error: Error) {
    Sentry.captureException(error);
  }

  public static captureMessage(message: string) {
    Sentry.captureMessage(message, Sentry.Severity.Info);
  }
}

export default BugTracker;
